import React from 'react'
import { connect } from 'react-redux'
import { Input, Label } from 'reactstrap';
import * as Redux from 'redux'
import { Help } from '../help'
import * as Actions from './actions'
import './styles.css'
import * as Types from './types'

interface Props {
  disabled?: boolean,
  event: string,
  helpType?: string,
  id: Types.StateChangeID
  is_active: boolean,
  key_name?: string,
  onChange: Actions.StateChangeAction,
  props?: any,
  text?: string
}

const ToggleButtonComponent = ({
  disabled = false,
  event,
  key_name = 'is_active',
  id,
  is_active,
  onChange,
  props,
  text }: Props) =>
  <label className="switch">
    <input type="checkbox"
           onChange={() => onChange(event, {id, key: key_name, new_value: !is_active, props})}
           checked={is_active}
           disabled={disabled} ></input>
    <span className="slider round"></span>
  </label>

interface UncontrolledProps {
  className?: string,
  is_active: boolean,
  label?: string,
  helpType?: string,
  onChange: () => Redux.Action,

}
export const UncontrolledToggleButton = ({
  className = null,
  is_active,
  label = null,
  onChange,
  helpType = null,
   }: UncontrolledProps) =>
   <div className={`toggle-button ${className}`}>
   <Label className="field-label">
    {label && <span>{label}</span>}
    {helpType && <Help helpType={helpType} id={helpType}/>}
  </Label>
  <label className="switch">
    <input type="checkbox"
      onChange={onChange}
      checked={is_active}></input>
    <span className="slider round"></span>
  </label>
</div>

const LabeledToggleButtonComponent = ({
  event,
  helpType,
  key_name = 'is_active',
  id,
  is_active,
  onChange,
  props,
  text }: Props) =>
<div className="rasa-input rasa-toggle-input">
  <Label className="field-label">
    <span>{text}</span>
    {helpType && <Help helpType={helpType} id={helpType}/>}
  </Label>
  <Label className="switch">
    <Input type="checkbox"
           onChange={() => onChange(event, {id, key: key_name, new_value: !is_active, props})}
           checked={is_active} ></Input>
    <span className="slider round"></span>
  </Label>
</div>

export const ToggleButton = connect(
  () => ({}),
  ({onChange: Actions.stateChange}),
)(ToggleButtonComponent)

export const LabeledToggleButton = connect(
  null,
  ({onChange: Actions.stateChange}),
)(LabeledToggleButtonComponent)



// WEBPACK FOOTER //
// ./src/components/is_active/toggle_button.tsx